<template>

 <v-app>
     
<router-view></router-view>
 </v-app>
  
  
  
</template>

<script>


export default {
  data () {
    return {
      
    }  
  },

  
}

</script>

<style>

</style>




// WEBPACK FOOTER //
// src/App.vue